<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt FhInt" id="HlicitacionesInt">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>LICITACIONES</h1>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
	</div>

    <div class="FformContacto dDiez dtDiez dmOnce mt-5 pb-1">
		<h3 class="text-center">BIENVENIDO ESTIMADO COLABORADOR</h3>
		<h4>Accede a la plataforma</h4>
		<div class="row">
			<div class="col-12 mt-3">
				<form #f="ngForm" (ngSubmit)="onSubmit(f)" ngNativeValidate class="pb-3 text-left">			
					<div class="row">
						<div class="form-group col-sm-12 col-lg-6 col-12 p-0">
							<label for="usuario">Usuario</label>
							<input ngModel name="usuario" type="text" id="usuario" aria-describedby="usuario" placeholder="Usuario" required class="form-control">
						</div>
						<div class="form-group col-sm-12 col-lg-6 col-12 p-0 pl-sm-0 pl-lg-2 pl-0">
							<label for="password">Contraseña</label>
							<div class="input-group">
								<input ngModel name="password" class="form-control flat" id="password" [type]="fieldTextType ? 'text' : 'password'" placeholder="Contraseña" required>
								<div class="input-group-prepend">
									<span class="input-group-text">
										<div class="iconoForm" [ngClass]="{
											'icono-eyeNo': !fieldTextType,
											'icono-eye': fieldTextType
											}" (click)="toggleFieldTextType()">
										</div>
									</span>
								</div>
							</div>

						</div>
					</div>
					<div class="col-sm-12 text-center mt-4">
						<button type="submit" class="btn btn-enviar">Entrar</button>
					</div>
				</form>
			</div>
		</div>
		<div class="row mt-3 mb-5">
			<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pb-2 text-left">
				<a [routerLink]="['/licitaciones/recuperar-contrasena']">¿Olvidaste tu contraseña?</a>
			</div>
		</div>
	</div>
	<div class="col-12 alerta-exito blqCtr text-center" *ngIf="this.fail">
		<img class="icono-error" src="./../../../../assets/images/icons/icono-error.png">
		<p>Los <strong>datos</strong> ingresados <strong>no están registrados</strong> en el sistema, favor de
			verificarlos.</p>
		<button class="btn-cancelar" (click)="closeok()">Aceptar</button>
	</div>

</div>